import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  typesdiFromES:"",
  typesdiToES:"",
  typesdiFromEN:"",
  typesdiToEN:"",
  isScanned:true, 
  notIsScanned:true,
  numberNTFrom:"",
  numberNTTo:"",
  dateSheetFrom:null,
  dateSheetTo:null,  
  ori_tras_store_idFrom:"",
  ori_tras_store_idTo:"",
  dest_tras_store_idFrom: "", 
  dest_tras_store_idTo: "" 
};

const filtersNTSlice = createSlice({
  name: 'filtersNT',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersNTSlice.actions;
export default filtersNTSlice.reducer;
